import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ServiceFeature {
  title: string;
  description: string;
}

export interface ServiceHighlight {
  topic: string;
  detail: string;
}

export interface ContactInfo {
  phone: string;
  email: string;
  location: string;
}

export interface TechnicalFeatureSection {
  heading: string;
  points: string[];
}

export interface Service {
  id: number;
  title: string;
  slug: string;
  category: string;
  image: string;
  image2: string;
  youtube: string;
  date: string;
  author: string;
  summary: string;
  mainContent: {
    title: string;
    description: string;
    heading: string;
    content: ServiceFeature[];
  };

  overview: {
    title: string;
    description: string;
    heading: string;
  };
  keyft: {
    title: string;
    description: string;
    heading: string;
  };
  benefits: {
    title: string;
    description: string;
    topic: string;
    details : string;
  };
  technical: {
    title: string;
    heading: string;
    point: string;
  };
  whyChooseUs: {
    title: string;
    point: string;
  };
  support: {
    title: string;
    point: string;
  };
  security: {
    title: string;
    point: string;
  };
   noteContent: {
    heading: string;
    description: string;
  };
  
  subContent: {
    title: string;
    description: string;
    othercontent: string;
    highlight: ServiceHighlight[];
  };
  technicalFeatures: {
    title: string;
    sections: TechnicalFeatureSection[];
  };
  solContent: {
    title: string;
    solution: {
      points: string[];
    }[];
  };
  supportContent: {
    title: string;
    content: {
      points: string[];
    }[];
  };
   securityContent: {
    title: string;
    content: {
      points: string[];
    }[];
  };
  oversight: {
    title: string;
    content: {
      description: string[];
    }[];
  };
  objectContent: {
    heading: string;
    title: string;
    content: {
      points: string[];
    }[];
  };
  featuredList: {
    title: string;
    lists: {
      name: string[];
      route: string[];
    }[];
  };

  contactInfo: ContactInfo;
  metaTags: Array<{
    name: string;
    content: string;
  }>;
}

@Injectable({
  providedIn: 'root'
})
export class ServiceDetail {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getServiceBySlug(slug: string): Observable<Service> {
    return this.http.get<Service>(`${this.apiUrl}/services/${slug}`);
  }
} 